import React from 'react';

import { Stack, Skeleton } from '../../ui';

export const ProviderProfileLoader = () => (
  <Stack
    padding={16}
    space={16}
    minWidth="100%"
    flexGrow={1}
    flexShrink={1}
  >
    <Skeleton width="100%" height="168px" widthRandomness={0} />
    <Skeleton width="100%" height="60px" widthRandomness={0} />
    <Skeleton width="100%" height="60px" widthRandomness={0} />
    <Skeleton width="100%" height="60px" widthRandomness={0} />
    <Skeleton width="100%" height="168px" widthRandomness={0} />
  </Stack>
);
